import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import React from "react";
import nodeinstance from "../../../../nodeInstance";
import { setAppError } from "../../../../store/userSlice";
import { GoCircle } from "react-icons/go";
import { CgSpinner } from "react-icons/cg";

export default function EmployeeListTable({
  propData,
  selectedCandidates,
  setSelectedCandidates,
  setClient,
  setDelayCount,
  setReqDate,
}) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const order = [
    "S.NO",
    "SELECT",
    "EMP ID",
    "EMP NAME",
    "CLIENT",
    "VISA PROVIDER",
    "NATIONALITY",
    "ACTUAL PROFESSION",
    "VISA PROFESSION",
    "PASSPORT NUMBER",
    "IQAMA",
    "SEQUENCE",
    "FROM DATE",
    "TENURE",
    "TILL DATE",
  ];

  const [searchWords, setSearchWords] = useState([]);

  console.log("Data to be seen on employeesite......", propData);
  const [date, setDate] = useState();
  const [clientId, setClientId] = useState();
  const handleClientChange = (e) => {
    setClientId(e.target.value);
    setClient(e.target.value);
  };
  const [employeeData, setEmpployeeData] = useState();
  const [search, setSearch] = useState();
  const [trigger, setTrigger] = useState(false);

  const getDataByClientName = async () => {
    if (clientId === null || clientId === undefined || clientId === "") {
      dispatch(
        setAppError({
          msg: "client value is required",
        })
      );
      return;
    }
    const reqObject = {
      id: clientId,
      arrival_date: date ? date : "NULL",
    };
    try {
      const response = await nodeinstance.post(
        "/dashboard/invoiceCostPlus/getEmployeeByClientId",
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        console.log("Data to be seen here......with post call", response);
        setEmpployeeData(response?.data?.data);
        setSearch(response?.data?.data);
        setTrigger(true);
        setDelayCount(response?.data?.data);
        setReqDate(date);
      }
    } catch (error) {
      console.log("error to be displayed for employee cost plus....", error);
      setTrigger(false);
      dispatch(
        setAppError({
          msg: "Unable to fetch employees.",
        })
      );
    }
  };
  console.log("employeeData......employeeData", employeeData);

  const handleCheckboxChange = (event, candidate_id) => {
    const isChecked = event.target.checked;
    setSelectedCandidates((prevState) => {
      if (isChecked) {
        if (!prevState.includes(candidate_id)) {
          return [...prevState, candidate_id];
        }
      } else {
        return prevState.filter((id) => id !== candidate_id);
      }
      return prevState;
    });
  };

  console.log("selected data to be seen here.....", selectedCandidates);

  const [isSearch, setIsSearch] = useState(false);
  const filter = (e) => {
    console.log("event to be seen here in console.", e.target.value);
    if (search?.length > 0) {
      const keyword = e.target.value;
      setIsSearch(true);
      if (keyword !== "") {
        const results = search.filter((user) => {
          // Define an array of keys you want to search in
          const keysToSearch = [
            "candidate_id",
            "name",
            "passport_number",
            "visa_profession",
            "actual_profession",
          ];
          // Check if any of the keys contain the keyword
          return keysToSearch.some((key) =>
            user[key]?.toLowerCase().includes(keyword.toLowerCase())
          );
        });
        setSearch(results);
      } else {
        setSearch(employeeData);
        // If the text field is empty, show all users
      }
    } else {
      dispatch(
        setAppError({
          msg: "No Data found for the given search",
        })
      );
    }
  };
  const [downloadLoading, setDownloadLoading] = useState(false);

  const downloadTemplate = async () => {
    setDownloadLoading(true);
    if (clientId === undefined || clientId === null) {
      dispatch(
        setAppError({
          msg: "Client is required....",
        })
      );
      setDownloadLoading(false);
      return;
    }
    try {
      const response = await nodeinstance.get(
        `/dashboard/invoiceCostPlus/downloadempDetailsExcel/${clientId}/${date ? date : "NULL"}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Employee list`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
      setDownloadLoading(false);
    }
  };
  const [filteredSearch, setFilteredSearch] = useState([]);

  useEffect(() => {
    // Filter the data and update the state
    const newFilteredSearch = search?.filter((listItem) => {
      const tillDateCondition =
        listItem.till_date === null
          ? false
          : new Date(listItem.till_date) > new Date(date);
      const fromDate = new Date(listItem.from_date);
      const tillDate = new Date(listItem.till_date);
      const inputDate = new Date(date);

      return (
        tillDateCondition &&
        ((inputDate >= fromDate && inputDate <= tillDate) ||
          inputDate > tillDate)
      );
    });

    setFilteredSearch(newFilteredSearch);
  }, [trigger]);
  console.log("filteredSearch..........", date);

  const [disabledDates, setDisabledDates] = useState([]);

  const calenderAPI = async () => {
    try {
      const res = await nodeinstance.get(
        `/dashboard/invoiceCostPlus/getDates/${clientId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setDisabledDates(res.data.data);
      }
    } catch (error) {
      console.log("Error fetching calendar data:", error);
    }
  };

  useEffect(() => {
    calenderAPI();
  }, [clientId]);

  const monthMap = {
    January: "01",
    February: "02",
    March: "03",
    April: "04",
    May: "05",
    June: "06",
    July: "07",
    August: "08",
    September: "09",
    October: "10",
    November: "11",
    December: "12",
  };

  const isDateDisabled = (year, month) => {
    return disabledDates?.some(
      (date) => date.start_year === year && monthMap[date.end_month] === month
    );
  };

  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const selectedYear = selectedDate.getFullYear();
    const selectedMonth = String(selectedDate.getMonth() + 1).padStart(2, "0");
    // if (!isDateDisabled(selectedYear, selectedMonth)) {
    //   alert("error.......");
    // } else {
    setDate(e.target.value);
    // }
  };
  console.log("Search Data to be printed here in console", search);
  return (
    <>
      <div className="pt-2 uppercase m-3">
        {/* <div className="flex flex-wrap  gap-2 w-full items-center "> */}
        <div className="flex flex-wrap gap-2 justify-betweem mb-1 items-center">
          {/* <h3 className="ml-4">EMPLOYEES COUNT: {selectedCandidates && selectedCandidates?.length} </h3> */}
          <h3 className="ml-4">
            EMPLOYEES COUNT:{" "}
            <span style={{ color: "red" }}>
              {selectedCandidates && selectedCandidates.length}
            </span>
          </h3>
          <div className="flex gap-2 ml-auto">
            <select
              className="border-[1px] border-border dark:bg-dark rounded-md h-10 p-1 mt-4 text-xs w-48"
              onChange={handleClientChange}
            >
              <option>{"SELECT CLIENT VALUE"}</option>
              {propData.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.client_id}>{data.client_name}</option>
                </React.Fragment>
              ))}
            </select>
            <input
              type="month"
              value={date}
              className="border-[1px] border-border dark:bg-dark rounded-md h-10 p-1 mt-4 text-xs"
              onChange={(e) => {
                handleDateChange(e);
              }}
              onKeyDown={(e) => e.preventDefault()}
            />
            <button
              className="p-1 px-2 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 h-10 p-3 mt-4"
              onClick={() => {
                getDataByClientName();
              }}
            >
              <p>Get Employee</p>
            </button>

            <input
              type="search"
              className={`input input-sm h-10 max-w-xs pl-8 w-full input-bordered focus:outline-none uppercase ml-auto text-lg p-2 mt-4`}
              placeholder={"Enter to search"}
              onChange={filter}
              disabled={search?.length <= 0 || !search}
            />

            <button
              className="p-1 px-2 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 h-10 p-3 mt-4"
              onClick={() => downloadTemplate()}
              disabled={downloadLoading}
            >
              <p>Download</p>
              {downloadLoading && <CgSpinner className="animate-spin" />}
            </button>
          </div>
          <div
            className="overflow-x-auto m-2"
            // style={{ backgroundColor: "white" }}
            style={
              employeeData?.length > 5
                ? { height: "250px", backgroundColor: "white" }
                : { backgroundColor: "white" }
            }
          >
            <table className="min-w-full divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  {order.map((columnName, index) => (
                    <th
                      key={index}
                      scope="col"
                      className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                    >
                      {columnName}
                    </th>
                  ))}
                </tr>
              </thead>
              {search?.length <= 0 ? (
                <div className="flex items-center justify-center w-full h-full m-4">
                  <div className="flex flex-col items-center gap-1 relative">
                    <h2>No Data found</h2>
                  </div>
                </div>
              ) : (
                <tbody className="bg-white divide-gray-10">
                  {search?.map((listItem, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {index + 1}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {/* {employeeData?.map((listItem) => ( */}
                        <input
                          key={listItem.candidate_id}
                          type="checkbox"
                          checked={selectedCandidates.includes(
                            listItem.candidate_id
                          )}
                          onChange={(event) =>
                            handleCheckboxChange(event, listItem.candidate_id)
                          }
                        />
                        {/* ))} */}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.candidate_id}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.client}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.visa_provider
                          ? listItem.visa_provider
                          : "----"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.nationality}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.actual_profession}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.visa_profession}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.passport_number}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.iqama_number}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.sequence === null ? 0 : listItem.sequence}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.new_from_date === null
                          ? listItem.from_date
                            ? new Date(listItem.from_date)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .split(" ")
                                .join("-")
                                .toUpperCase()
                            : "-----"
                          : listItem.new_from_date
                            ? new Date(listItem.new_from_date)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .split(" ")
                                .join("-")
                                .toUpperCase()
                            : "-----"}
                      </td>

                      <td className="px-6 py-4 whitespace-nowrap">
                        {listItem.tenure}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {" "}
                        {listItem.till_date
                          ? new Date(listItem.till_date)
                              .toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                              .split(" ")
                              .join("-")
                              .toUpperCase()
                          : "-----"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        </div>
        {/* <Pagination /> */}
      </div>
    </>
  );
}
